import { render, staticRenderFns } from "./ConsolidatePrize.vue?vue&type=template&id=5e8b06cc&"
import script from "./ConsolidatePrize.vue?vue&type=script&lang=js&"
export * from "./ConsolidatePrize.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports